import { Component, input, Input } from '@angular/core';
import { Station } from '../../models/stationModel';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { InvocingService } from '../../services/invocing.service';
import { AlertModalComponent } from '../alert-modal/alert-modal.component';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-invoice',
    imports: [CommonModule, FormsModule, NgxMaskDirective, AlertModalComponent],
    templateUrl: './invoice.component.html',
    styleUrl: './invoice.component.scss',
    providers: [provideNgxMask()]
})
export class InvoiceComponent {
  showModalCP = false;
  isSuccess = false;
  isConfirm = true;
  messagesError = "";
  showMasiveError = false;
    reporterURL=environment.wrUrl;
  
  constructor(private service: InvocingService) {

  }
  @Input() isInvoiced=false;
  @Input() invoiceCompany!: Station;
  @Input() invoiceToCompany: any;
  @Input() consumptions!: any[];
  @Input() dateInvoice!: Date;
  @Input() client!: number;
  zipCode!: any;
  disabledZipCode = false;

  ngOnInit() {
    this.zipCode = this.invoiceToCompany.zipCode;
    console.log(this.consumptions);
  }
  ngOnChanges() {
    if (this.invoiceToCompany) {  
      this.zipCode = this.invoiceToCompany.zipCode;
      
    }
  }

  updateZipCode() {
  
    if (this.zipCode != '' && this.zipCode.length == 5) {
      this.service.updateZipCode(this.client, this.zipCode).subscribe({
        next: (data: any) => {
          this.invoiceToCompany.zipCode=this.zipCode;
          this.disabledZipCode = true;
        },
        error: (error: any) => {
          this.disabledZipCode = false;
        },
      });
    } else {
      this.disabledZipCode = true;
    }
  }

  showModalCPAction() {
    this.messagesError = "¿Está seguro de actualizar el código postal a: <b>" + this.zipCode + "</b>?";
    this.showModalCP = true;
  }

  downloadFile(invoice:any,type:string){
    let url ='' 
    if(type=='PDF'){
     
     url = this.reporterURL+type+'/MonederoXiga.aspx?rptId=data&DataServer=NexusFEMonedero&langId=2&rptName=rpt_electronicPurseInvoiceSingle&invoiceId='+invoice.invoiceId;
    }else{
      

     url = this.reporterURL+'pdf/MonederoXiga.aspx?rptId=xml&invoiceId='+invoice.invoiceId;
    }
   
    window.open(url, "_blank");
  }

}
